import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './council-map.module.scss';
import { setActiveCouncil, setComparedCouncil } from '../../actions/ui';
import 'leaflet/dist/leaflet.css';
import MapBanner from './map-banner';
import RegionMap from '../region-map';
import * as selectors from '../../reducers';

const CouncilMapContainer = ({
  council,
  comparing,
  onCouncilSelect,
  isComparisonCouncil,
  comparisonId,
  setActiveCouncil,
  setComparedCouncil,
  isMobile,
}) => {
  const handleCloseClicked = () => {
    if (isComparisonCouncil) {
      // Close the comparison one only
      setComparedCouncil(null);
    } else {
      // Close the current active one, and make the other one active.
      setActiveCouncil(comparisonId);
      // Now close the comparison one.
      setComparedCouncil(null);
    }
  };

  return (
    <div
      className={`councilMapWrapper ${styles.councilWrapper}`}
      data-comparing={comparing}
    >
      <MapBanner
        council={council}
        comparing={comparing}
        onCloseClicked={handleCloseClicked}
      />
      <div className={`${styles.mapWrapper}`}>
        <RegionMap
          council={council}
          onCouncilSelect={onCouncilSelect}
          scrollZoom={false}
        />
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  setActiveCouncil,
  setComparedCouncil,
};

const mapStateToProps = (state) => ({
  isMobile: selectors.getIsMobile(state),
});

CouncilMapContainer.propTypes = {
  onCouncilSelect: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CouncilMapContainer);



// WEBPACK FOOTER //
// ./src/components/council-map-container/council-map-container.js